import { createRegistry } from '../createRegistry';
export const registry = createRegistry({
    host: 'corvidBuilder',
});
export default registry;
export * from '../types';
//# sourceMappingURL=corvidBuilder.js.map